import React, { useState, useEffect, useRef } from 'react';
import {
	Container,
	Row,
	Col,
	Card,
	Modal,
	Button,
	OverlayTrigger,
	Tooltip,
	Spinner,
} from 'react-bootstrap';
import {
	Link,
	useNavigate,
	useParams,
	useSearchParams,
} from 'react-router-dom';
import {
	Collection,
	Diagram3Fill,
	House,
	InfoCircle,
	Grid3x2GapFill,
	ListCheck,
	ChevronRight,
	ChevronLeft,
} from 'react-bootstrap-icons';
import SimpleSection from '../components/SimpleSection';
import AboutLayout from '../layouts/AboutLayout';

import SearchToolbar from '../components/SearchToolbar';
import AboutLayoutLoading from '../layouts/AboutLayoutLoading';
import useIsInViewport from '../hooks/useIsInViewport';
import useIntersectionObserver from '../hooks/useIntersectionObserver';

export default function ISADgAgency(props) {
	let { isadg } = useParams();

	const [prevCollections, setPrevCollections] = useState([]);
	const loadMoreHierarchyRef = useRef(null);
	const isLoadMoreHierarchyInViewport = useIsInViewport(
		loadMoreHierarchyRef.current
	);
	const [searchParams, setSearchParams] = useSearchParams();
	const page = searchParams.get('page') || 1;
	//const [page, setPage] = useState(1);
	const { apiService } = props;
	const [IsadgMetadata, setIsadgMetadata] = useState({
		isLoading: true,
		payload: {},
	});
	const [collections, setCollections] = useState({
		isLoading: false,
		payload: [],
	});
	const [collectionOnDetail, setCollectionOnDetail] = useState({
		isLoading: true,
		payload: {},
	});
	const [showModal, setShowModal] = useState({
		visible: false,
		collection: '',
	});
	const [displaySetup, setDisplaySetup] = useState({ variant: 'boxes' });

	const [orderby, setOrderby] = useState({ type: 'asc', order: 'codRef' });
	const [showModalScheme, setShowModalScheme] = useState({
		visible: false,
		collectionInfo: null,
		lastData: null,
		collectionOnDetail: [],
	});
	const [hierarchyPage, setHierarchyPage] = useState({
		isLoading: false,
		page: 1,
		pagination: null,
		lastData: null,
	});
	const [loadedPages, setLoadedPages] = useState([]);
	const navigate = useNavigate();

	useEffect(() => {
		/* console.log('isadg', isadg);
		console.log('page', page); */
		//if (loadedPages.includes(page)) return;
		try {
			setIsadgMetadata((prevData) => ({ ...prevData, payload: {} }));
			setCollections((prevData) => ({ ...prevData, isLoading: true }));
			apiService.getAgencySolr(
				{
					params: {
						repository: isadg.replace('GT-', ''),
						page: page ?? 1,
						sortby: orderby.order,
						sorttype: orderby.type,
					},
				},
				{},
				(_, rdata) => {
					//console.log('returned data', rdata);
					setIsadgMetadata({ isLoading: false, payload: rdata });
					const collections_response = Array.isArray(
						rdata?.collections
					)
						? rdata.collections
						: [rdata?.collections];
					setCollections((prevData) => ({
						isLoading: false,
						payload: [...prevData.payload, ...collections_response],
					}));

					//setSearchParams({ page });
					/* setSearchParams({
						page: page ?? 1,
					}); */
					setLoadedPages((prevData) => [...prevData, +page]);
				}
			);
		} catch (e) {
			//console.log(e);
			setIsadgMetadata({ isLoading: false, payload: {} });
			setCollections((prevData) => ({ ...prevData, isLoading: false }));
		}
		return () => {
			setCollections((prevData) => ({ ...prevData, isLoading: false }));
			setIsadgMetadata((prevData) => ({ ...prevData, isLoading: false }));
		};
	}, [page, isadg, apiService, orderby]);

	useEffect(() => {
		const dataset1 = loadMoreRef.current?.dataset;
		const dataset2 = loadPrevRef.current?.dataset;
		if (dataset1 && dataset2) {
			//console.log('orderby', orderby);
			//setPage(1);
			setSearchParams(
				{
					page: 1,
					sortby: orderby.order,
					sorttype: orderby.type,
				},
				{ replace: true }
			);
			setLoadedPages([]);
			dataset1.isloading = true;
			dataset2.isloading = true;
		}
		setCollections((prevData) => ({ ...prevData, payload: [] }));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [orderby]);

	const showNames = (namesArray, length = 3) =>
		`${namesArray.slice(0, length).join('; ')} ${
			namesArray.length > length ? '...' : ''
		}`;

	function handleInfoClickDetail(whichone) {
		try {
			setShowModal({
				visible: true,
				collection: whichone,
			});
			setCollectionOnDetail({ isLoading: true, payload: {} });
			apiService.getCollectionInfoSolr(
				{
					params: {
						repository: isadg.replace('GT-', ''),
						isadg: whichone.trim(),
					},
				},
				{},
				(_, rdata) =>
					setCollectionOnDetail({
						isLoading: false,
						payload: { ...rdata.father },
					})
			);
		} catch (e) {
			//console.log(e);
			setShowModal({
				visible: false,
				collection: '',
			});

			setCollectionOnDetail({ isLoading: false, payload: {} });
		}
	}
	function handleInfoClickHierarchy(whichone) {
		//console.log(whichone);
		try {
			setShowModalScheme({
				visible: true,
				collectionInfo: whichone,
				lastData: null,
				collectionOnDetail: [],
			});
			setCollectionOnDetail({ isLoading: true, payload: {} });
			apiService.getCollectionInfoSolr(
				{
					params: {
						repository: isadg.replace('GT-', ''),
						isadg: whichone.trim(),
						page: 1,
					},
				},
				{},
				(_, rdata) => {
					//console.log('returned data', rdata);
					setCollectionOnDetail({
						isLoading: false,
						payload: rdata.father,
					});
					setShowModalScheme((originalState) => ({
						...originalState,
						collectionInfo: rdata.father,
						collectionOnDetail: rdata?.collections ?? [],
					}));
					setHierarchyPage((prevHierarchy) => ({
						...prevHierarchy,
						isLoading: false,
						pagination: rdata?.result_header?.pagination,
						page: 1,
					}));
				}
			);
		} catch (e) {
			//console.log(e);
			setShowModalScheme({
				visible: true,
				collectionInfo: null,
				lastData: null,
				collectionOnDetail: [],
			});

			setCollectionOnDetail({ isLoading: false, payload: {} });
		}
	}

	function nextLevelScheme(father) {
		//console.log(father);
		try {
			setCollectionOnDetail((prevData) => ({
				isLoading: true,
				...prevData,
			}));
			apiService.getCollectionInfoSolr(
				{
					params: {
						repository: isadg.replace('GT-', ''),
						isadg: father,
						page: 1,
					},
				},
				{},
				(_, rdata) => {
					//console.log('returned data', rdata);
					setCollectionOnDetail((prevData) => ({
						isLoading: false,
						payload: rdata.father,
					}));
					setShowModalScheme((originalState) => ({
						...originalState,
						lastData: originalState,
						collectionOnDetail: rdata?.collections ?? [],
					}));
					setHierarchyPage((prevHierarchy) => ({
						...prevHierarchy,
						isLoading: false,
						pagination: rdata?.result_header?.pagination,
						lastData: prevHierarchy,
						page: 1,
					}));
				}
			);
		} catch (e) {
			setCollectionOnDetail((prevData) => ({
				isLoading: false,
				...prevData,
			}));
		}
	}

	useEffect(() => {
		//console.log('ishierarchy', isLoadMoreHierarchyInViewport);
		if (
			isLoadMoreHierarchyInViewport &&
			!hierarchyPage.isLoading &&
			hierarchyPage.page < hierarchyPage?.pagination?.total_pages
		) {
			setHierarchyPage((prevHierarchy) => ({
				...prevHierarchy,
				isLoading: true,
				page: prevHierarchy.page + 1,
			}));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoadMoreHierarchyInViewport]);

	useEffect(() => {
		try {
			apiService.getCollectionInfoSolr(
				{
					params: {
						repository: isadg.replace('GT-', ''),
						isadg: collectionOnDetail.payload.id,
						page: hierarchyPage.page,
					},
				},
				{},
				(_, rdata) => {
					//console.log('returned data', rdata);
					const newCollection = rdata?.collections
						? Array.isArray(rdata.collections)
							? rdata.collections
							: [rdata.collections]
						: [];
					setShowModalScheme((originalState) => ({
						...originalState,
						collectionOnDetail: [
							...originalState.collectionOnDetail,
							...newCollection,
						],
					}));
					setHierarchyPage((prevHierarchy) => ({
						...prevHierarchy,
						isLoading: false,
						pagination: rdata?.result_header?.pagination,
					}));
				}
			);
		} catch (e) {
			//console.log(e);
			setShowModalScheme((originalState) => ({
				...originalState,
			}));
			setHierarchyPage((prevHierarchy) => ({
				...prevHierarchy,
				isLoading: false,
			}));
		}
		return () => {
			setShowModalScheme((originalState) => ({
				...originalState,
			}));
			setHierarchyPage((prevHierarchy) => ({
				...prevHierarchy,
				isLoading: false,
			}));
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hierarchyPage.page]);

	const renderTooltip = (props) => (
		<Tooltip id='button-tooltip' {...props}>
			{props?.text}
		</Tooltip>
	);

	const handleIntersectionMore = (entry) => {
		if (entry.isIntersecting) {
			const dataset = loadMoreRef.current?.dataset;
			//console.log('dataset', dataset);
			if (+dataset?.currentpage >= +dataset?.totalpages) return;
			if (dataset?.isloading === 'false') {
				/* setPage((prevPage) => {
				const new_page = +prevPage + 1;
				dataset.isloading = true;
				return new_page;
			}); */
				//searchParams.set('page', +dataset?.currentpage + 1);
				setSearchParams(
					{
						page: +dataset?.currentpage + 1,
					},
					{ replace: true }
				);
				dataset.isloading = true;
			}
		}
	};
	const loadMoreRef = useIntersectionObserver(handleIntersectionMore, {
		rootMargin: '200px',
	});

	const handleIntersectionPrev = (entry) => {
		if (entry.isIntersecting && !collections.isLoading) {
			const loadPrevData = async () => {
				try {
					const dataset = loadPrevRef.current?.dataset;
					const prev_page = +dataset?.currentpage - 1;
					console.log('prev_page', prev_page);
					console.log('loadedPages', loadedPages);
					console.log(loadedPages.includes(+prev_page));
					if (loadedPages.includes(prev_page)) return;
					setCollections((prevData) => ({
						...prevData,
						isLoading: true,
					}));

					apiService
						.getAgencySolr(
							{
								params: {
									repository: isadg.replace('GT-', ''),
									page: prev_page ?? 1,
									sortby: orderby.order,
									sorttype: orderby.type,
								},
							},
							{},
							(_, rdata) => {
								console.log('returned data', rdata);
								setIsadgMetadata({
									isLoading: false,
									payload: rdata,
								});
								const collections_response = Array.isArray(
									rdata?.collections
								)
									? rdata.collections
									: [rdata?.collections];
								setLoadedPages((prevData) => [
									+prev_page,
									...prevData,
								]);
								setCollections((prevData) => {
									return {
										isLoading: true,
										payload: [
											...collections_response,
											...prevData.payload,
										],
									};
								});
								return collections_response;
							}
						)
						.then((res) => {
							document
								.getElementById(res[res.length - 1].id)
								.scrollIntoView();
							const interval = setInterval(() => {
								if (
									document.getElementById(
										res[res.length - 1].id
									)
								) {
									clearInterval(interval);
									document
										.getElementById(res[res.length - 1].id)
										.scrollIntoView();
									setTimeout(() => {
										setCollections((prevData) => ({
											...prevData,
											isLoading: false,
										}));
									}, 1500);
								}
							}, 500);
						});
				} catch (e) {
					//console.log(e);
					setIsadgMetadata({ isLoading: false, payload: {} });
					setCollections((prevData) => ({
						isLoading: false,
						payload: [...prevCollections, ...prevData.payload],
					}));
					setPrevCollections([]);
				}
			};
			const dataset = loadPrevRef.current?.dataset;
			if (+dataset?.currentpage <= 1) return;
			if (dataset?.isloading === 'false' && !collections.isLoading) {
				//dataset.isloading = true;
				loadPrevData();
			}
		}
	};
	const loadPrevRef = useIntersectionObserver(handleIntersectionPrev, {
		rootMargin: '-50px',
	});

	if (IsadgMetadata.isLoading)
		return (
			<AboutLayoutLoading
				backgroundImage={
					isadg.includes('GT-CIRMA-FG') ? 'fototeca' : 'archivo'
				}
				search
				title={
					isadg.includes('GT-CIRMA-FG')
						? 'Fototeca Guatemala'
						: 'Archivo Histórico'
				}
				collection
			>
				<SimpleSection className='c-agency-list'>
					<Container className='cfil'>
						<Row>
							<Col xl={11} sm={11} xs={11}>
								<SearchToolbar
									payload={{
										isLoading: false,
										total: '...',
									}}
									orderby={orderby}
									setOrderby={setOrderby}
								/>
							</Col>
							<Col xl={1} sm={1} xs={1} className='lyd'>
								<Button
									variant={'light'}
									onClick={() => {
										setDisplaySetup({
											variant:
												displaySetup.variant === 'list'
													? 'boxes'
													: 'list',
										});
									}}
								>
									{displaySetup.variant !== 'boxes' ? (
										<Grid3x2GapFill />
									) : (
										<ListCheck />
									)}
								</Button>
							</Col>
						</Row>
					</Container>
				</SimpleSection>
				<SimpleSection className='c-agency-list loading'>
					<Container>
						<Row>
							{new Array(16).fill('').map((_, ci) => (
								<Col lg={3} key={ci}>
									<Card className='cisadgccrd'>
										<div className='ci-crd-imgc'>
											<div className='imgbk animated'></div>
										</div>
										<Card.Body>
											<Card.Title>
												<div className='isadgid animated'>
													...
												</div>
												<div className='animated'>
													...
												</div>
											</Card.Title>
										</Card.Body>
									</Card>
								</Col>
							))}
						</Row>
					</Container>
				</SimpleSection>
			</AboutLayoutLoading>
		);
	//console.log('collection on detail> ', collectionOnDetail);
	if (!IsadgMetadata.isLoading)
		return (
			<AboutLayout
				title={
					isadg.includes('GT-CIRMA-FG')
						? 'Fototeca Guatemala'
						: 'Archivo Histórico'
				}
				variant='agency'
				subtitle={
					isadg.includes('GT-CIRMA-FG')
						? 'Fototeca Guatemala'
						: 'Archivo Histórico'
				}
				backgroundImage={
					isadg.includes('GT-CIRMA-FG') ? 'fototeca' : 'archivo'
				}
				subtitleIcon={<House />}
				search
				button={true}
				collection
			>
				<SimpleSection className='c-agency-list'>
					<Container className='cfil'>
						<Row>
							<div
								id='loadPrev'
								ref={loadPrevRef}
								data-currentpage={loadedPages[0] || 1}
								data-totalpages={
									IsadgMetadata.payload?.result_header
										?.pagination?.total_pages ?? 1
								}
								data-isloading={collections.isLoading}
							/>
							<Col xl={11} sm={11} xs={11}>
								<SearchToolbar
									payload={{
										isLoading: false,
										total:
											IsadgMetadata.payload?.result_header
												?.total_results ?? '...',
									}}
									orderby={orderby}
									setOrderby={setOrderby}
								/>
							</Col>
							<Col
								xl={1}
								sm={1}
								xs={1}
								className='lyd d-flex align-items-center justify-content-end'
							>
								<Button
									variant={'light'}
									onClick={() => {
										setDisplaySetup({
											variant:
												displaySetup.variant === 'list'
													? 'boxes'
													: 'list',
										});
									}}
								>
									{displaySetup.variant !== 'boxes' ? (
										<Grid3x2GapFill />
									) : (
										<ListCheck />
									)}
								</Button>
							</Col>
						</Row>
					</Container>
					<Container>
						<div className='d-flex justify-content-center'>
							{collections.isLoading && (
								<Spinner animation='border' role='status'>
									<span className='visually-hidden'>
										Loading...
									</span>
								</Spinner>
							)}
						</div>
						{displaySetup.variant === 'boxes' ? (
							<Row>
								{collections.isLoading &&
									collections.payload.length === 0 &&
									new Array(16).fill('').map((_, ci) => (
										<Col lg={3} key={ci}>
											<Card className='cisadgccrd'>
												<div className='ci-crd-imgc'>
													<div className='imgbk animated'></div>
												</div>
												<Card.Body>
													<Card.Title>
														<div className='isadgid animated'>
															...
														</div>
														<div className='animated'>
															...
														</div>
													</Card.Title>
												</Card.Body>
											</Card>
										</Col>
									))}
								{/* {prevCollections &&
									collections.isLoading &&
									new Array(8).fill('')?.map((_, ci) => (
										<Col lg={3} key={ci}>
											<Card className='cisadgccrd'>
												<div className='ci-crd-imgc'>
													<div className='imgbk animated'></div>
												</div>
												<Card.Body>
													<Card.Title>
														<div className='isadgid animated'>
															...
														</div>
														<div className='animated'>
															...
														</div>
													</Card.Title>
												</Card.Body>
											</Card>
										</Col>
									))} */}
								{collections.isLoading &&
									collections.payload.length === 0 &&
									new Array(16).fill('').map((_, ci) => (
										<Col lg={3} key={ci}>
											<Card className='cisadgccrd'>
												<div className='ci-crd-imgc'>
													<div className='imgbk animated'></div>
												</div>
												<Card.Body>
													<Card.Title>
														<div className='isadgid animated'>
															...
														</div>
														<div className='animated'>
															...
														</div>
													</Card.Title>
												</Card.Body>
											</Card>
										</Col>
									))}
								{collections.payload.map((cx, ci) => {
									let thisURL = process.env.PUBLIC_URL;
									thisURL +=
										+cx?.decendents > 0
											? '/collection/' + cx.id
											: '/item/' + cx.id;
									const thumbnail = cx?.thumbnail.trim();
									const isImageNull = [
										'',
										'null',
										'NULL',
									].includes(thumbnail);
									const imgURL = !isImageNull
										? cx?.thumbnail
										: apiService.__getDefaultThumbSrc(
												isadg
										  );
									return (
										<Col xs={12} md={6} lg={3} key={ci}>
											<Link
												to={thisURL}
												preventscrollreset='false'
											>
												<Card
													className='cisadgccrd'
													id={cx.id}
												>
													<div className='ci-crd-imgc'>
														<div
															className={
																'imgbk' +
																(!isImageNull
																	? ''
																	: ' default')
															}
															style={{
																backgroundImage:
																	'url(' +
																	imgURL +
																	')',
															}}
														></div>
														<div className='ci-crd-imgo'></div>
														<div className='ci-crd-imgo-cnt'>
															<div className='ci-crd-imgo-empty'></div>
															<div className='ci-crd-imgo-info-cnt'>
																{cx?.producer && (
																	<div className='ci-crd-imgo-info'>
																		<span className='ci-crd-imgo-info-key'>
																			<b>
																				Productor:
																			</b>
																		</span>
																		<span className='ci-crd-imgo-info-value'>
																			{Array.isArray(
																				cx.producer
																			)
																				? showNames(
																						cx.producer
																				  )
																				: cx.producer}
																		</span>
																	</div>
																)}
																{cx?.authors && (
																	<div className='ci-crd-imgo-info'>
																		<span className='ci-crd-imgo-info-key'>
																			<b>
																				Autor:
																			</b>
																		</span>
																		<span className='ci-crd-imgo-info-value'>
																			{Array.isArray(
																				cx.authors
																			)
																				? showNames(
																						cx.authors
																				  )
																				: cx.authors}
																		</span>
																	</div>
																)}
																{cx?.fecha && (
																	<div className='ci-crd-imgo-info'>
																		<span className='ci-crd-imgo-info-key'>
																			<b>
																				Fecha:
																			</b>
																		</span>
																		<span className='ci-crd-imgo-info-value'>
																			{
																				cx.fecha
																			}
																		</span>
																	</div>
																)}
															</div>
															<div className='ci-crd-act'>
																<div
																	onClick={(
																		evc
																	) => {
																		evc.preventDefault();
																		evc.stopPropagation();
																		handleInfoClickHierarchy(
																			cx.id
																		);
																	}}
																>
																	<OverlayTrigger
																		placement='top'
																		delay={{
																			show: 250,
																			hide: 400,
																		}}
																		overlay={(
																			props
																		) =>
																			renderTooltip(
																				{
																					...props,
																					text: 'Ver Esquema',
																				}
																			)
																		}
																	>
																		<Diagram3Fill />
																	</OverlayTrigger>
																</div>

																<div
																	onClick={(
																		evc
																	) => {
																		evc.preventDefault();
																		evc.stopPropagation();
																		handleInfoClickDetail(
																			cx.id
																		);
																	}}
																>
																	<OverlayTrigger
																		placement='top'
																		delay={{
																			show: 250,
																			hide: 400,
																		}}
																		overlay={(
																			props
																		) =>
																			renderTooltip(
																				{
																					...props,
																					text: 'Más Información',
																				}
																			)
																		}
																	>
																		<InfoCircle />
																	</OverlayTrigger>
																</div>
															</div>
														</div>
													</div>
													<Card.Body>
														<Card.Title>
															<div className='isadgid'>
																{cx.id}
															</div>
															{cx.title}
														</Card.Title>
													</Card.Body>
												</Card>
											</Link>
										</Col>
									);
								})}
							</Row>
						) : (
							<Container>
								<Row className='tblh' key={0}>
									<Col xl={2}>Código</Col>
									<Col xl={10}>Título</Col>
								</Row>
								{collections.isLoading &&
									collections.payload.length === 0 &&
									new Array(20).fill(0).map((_, i) => (
										<Row
											key={i + 1}
											className={
												i % 2 === 0 ? 'odd' : 'even'
											}
										>
											<Col xl={2}>
												<div className='skeleton'>
													<div className='skeleton__text'>
														...
													</div>
												</div>
											</Col>
											<Col xl={10}>
												<div className='skeleton'>
													<div className='skeleton__text'>
														...
													</div>
												</div>
											</Col>
										</Row>
									))}
								{collections.payload.map((cx, ci) => (
									<Row
										key={ci + 1}
										className={
											ci % 2 === 0 ? 'odd' : 'even'
										}
									>
										<Col xl={2}>
											<Link
												to={`${
													process.env.PUBLIC_URL
												}/${
													+cx.decendents > 0
														? 'collection'
														: 'item'
												}/${cx.id}`}
											>
												{cx.id}:
											</Link>
										</Col>
										<Col xl={10}>
											<Link
												to={`${
													process.env.PUBLIC_URL
												}/${
													+cx.decendents > 0
														? 'collection'
														: 'item'
												}/${cx.id}`}
											>
												{cx.title}
											</Link>
										</Col>
									</Row>
								))}
							</Container>
						)}
						<div
							className='d-flex justify-content-center'
							id='loadMore'
							ref={loadMoreRef}
							data-currentpage={page}
							data-totalpages={
								IsadgMetadata.payload?.result_header?.pagination
									?.total_pages ?? 1
							}
							data-isloading={collections.isLoading}
						>
							{collections.isLoading && (
								<Spinner animation='border' role='status'>
									<span className='visually-hidden'>
										Loading...
									</span>
								</Spinner>
							)}
						</div>
					</Container>
				</SimpleSection>

				<Modal
					centered
					show={showModal.visible}
					onHide={() =>
						setShowModal({
							visible: false,
							collection: '',
						})
					}
				>
					{!collectionOnDetail.isLoading ? (
						<div className='gag-mo'>
							<Container>
								<Row>
									<Col lg={5} className='gag-mo-img-cnt'>
										<img
											src={
												!['', 'null', 'NULL'].includes(
													collectionOnDetail.payload
														.thumbnail
												)
													? collectionOnDetail.payload
															.thumbnail
													: apiService.__getDefaultThumbSrc(
															isadg
													  )
											}
											style={{
												width: '320px',
												height: 'auto',
											}}
											alt=''
										/>
									</Col>
									<Col lg={7}>
										<div className='mod-code'>
											{collectionOnDetail?.payload?.id}
										</div>
										<h2>
											{collectionOnDetail?.payload?.title}
										</h2>
										{collectionOnDetail?.payload
											?.authors && (
											<div className='mod-info-cnt'>
												<label>Autor: </label>{' '}
												{Array.isArray(
													collectionOnDetail?.payload
														?.authors
												)
													? showNames(
															collectionOnDetail
																?.payload
																?.authors,
															collectionOnDetail
																?.payload
																?.authors.length
													  )
													: collectionOnDetail
															?.payload?.authors}
											</div>
										)}
										{collectionOnDetail?.payload?.fecha && (
											<div className='mod-info-cnt'>
												<label>Fecha: </label>{' '}
												{
													collectionOnDetail?.payload
														?.fecha
												}
											</div>
										)}
										{collectionOnDetail?.payload
											?.extent && (
											<div className='mod-info-cnt'>
												<label>
													Volumen y soporte de la
													unidad de descripción:
												</label>{' '}
												<div
													dangerouslySetInnerHTML={{
														__html: Array.isArray(
															collectionOnDetail
																?.payload
																?.extent
														)
															? collectionOnDetail?.payload?.extent.join(
																	'<br />'
															  )
															: collectionOnDetail?.payload?.extent.replace(
																	/, (\d+)/g,
																	',<br /> $1'
															  ),
													}}
												/>
											</div>
										)}
										<div className='mod-info-cnt'>
											<Link
												to={`${
													process.env.PUBLIC_URL
												}/${
													+collectionOnDetail.payload
														.decendents > 0
														? 'collection'
														: 'item'
												}/${collectionOnDetail.payload.id?.trim()}`}
											>
												<Button variant='outline-primary'>
													<Collection /> IR A LA
													COLECCI&Oacute;N
												</Button>
											</Link>
										</div>
									</Col>
								</Row>
							</Container>
						</div>
					) : (
						<div className='gag-mo'>
							<Container>
								<Row>
									<Col xl={5}>
										<div
											className='animated'
											style={{
												width: '100%',
												height: '295px',
											}}
										>
											{' '}
										</div>
									</Col>
									<Col xl={7}>
										<div className='animated'> ... </div>
										<h2 className='animated'> ... </h2>
										<div>
											<label>Autor:</label>
											<div className='animated'>...</div>
										</div>
										<div>
											<label>Fecha:</label>
											<div className='animated'>...</div>
										</div>
										<div>
											<label>
												Volumen y soporte de la unidad
												de descripción:
											</label>
											<div className='animated'>...</div>
										</div>
										<div className='animated'>
											<Collection />
											...
										</div>
									</Col>
								</Row>
							</Container>
						</div>
					)}
				</Modal>
				<Modal
					centered
					show={showModalScheme.visible}
					onHide={() =>
						setShowModalScheme({
							visible: false,
							collectionInfo: null,
							lastData: null,
							collectionOnDetail: [],
						})
					}
					className='scheme-modal'
				>
					{!collectionOnDetail.isLoading &&
						showModalScheme.collectionInfo !== null && (
							<>
								<Modal.Header className='c-scheme-header'>
									{showModalScheme?.lastData && (
										<div
											className='c-scheme-header-back'
											onClick={() => {
												setShowModalScheme(
													(prevData) => ({
														visible: true,
														collectionInfo: {
															...prevData.collectionInfo,
														},
														lastData:
															prevData?.lastData
																?.lastData ??
															null,
														collectionOnDetail: [
															...(prevData
																?.lastData
																.collectionOnDetail ??
																[]),
														],
													})
												);
												setHierarchyPage(
													(prevHierarchy) => ({
														...prevHierarchy,
														isLoading: false,
														page: 1,
														lastData: prevHierarchy,
														pagination: null,
													})
												);
											}}
										>
											<ChevronLeft
												color='black'
												size={20}
											/>{' '}
											<b>Atrás</b>
										</div>
									)}
									<span className='c-scheme-collection-subtitle'>
										{showModalScheme.collectionInfo.id}
									</span>
									<h2 className='c-scheme-collection-title'>
										{showModalScheme.collectionInfo.title}
									</h2>
									<span className='c-scheme-collection-subtitle'>
										{showModalScheme?.lastData
											? 'Sub-series'
											: 'Series'}
										:
									</span>
								</Modal.Header>
								<Modal.Body className='c-scheme-body'>
									{showModalScheme?.collectionOnDetail
										?.length === 0 && (
										<div className='c-scheme-collection-item'>
											<div className='c-scheme-collection-item-info'>
												<div className='c-scheme-collection-item-title'>
													No contiene series esta
													colección
												</div>
											</div>
										</div>
									)}
									{showModalScheme?.collectionOnDetail
										?.length > 0 &&
										showModalScheme?.collectionOnDetail?.map(
											(item, indx) => {
												return (
													<div
														className='c-scheme-collection-item'
														key={indx}
														onClick={() => {
															if (
																+item?.decendents >
																0
															)
																nextLevelScheme(
																	item.id
																);
															else
																navigate(
																	`${process.env.PUBLIC_URL}/item/${item.id}`
																);
														}}
													>
														<div className='c-scheme-collection-item-info'>
															<div className='c-scheme-collection-item-code'>
																{item.id}
															</div>
															<div className='c-scheme-collection-item-title'>
																{item.title}
															</div>
														</div>
														{+item?.decendents >
															0 && (
															<div className='c-scheme-collection-item-icon'>
																<ChevronRight
																	color='black'
																	size={25}
																/>
															</div>
														)}
													</div>
												);
											}
										)}
									<div
										className='d-flex justify-content-center'
										id='loadMore'
										ref={loadMoreHierarchyRef}
									>
										{hierarchyPage.page <
											+hierarchyPage.pagination
												?.total_pages &&
											!hierarchyPage.isLoading && (
												<Spinner
													animation='border'
													role='status'
												>
													<span className='visually-hidden'>
														Loading...
													</span>
												</Spinner>
											)}
									</div>
								</Modal.Body>
							</>
						)}
					{collectionOnDetail.isLoading &&
						showModalScheme.collectionInfo !== null && (
							<>
								<Modal.Header className='c-scheme-header'>
									<span className='c-scheme-collection-subtitle'>
										<div className='animated'>...</div>
									</span>
									<h2 className='c-scheme-collection-title'>
										<div className='animated'>...</div>
									</h2>
									<span className='c-scheme-collection-subtitle'>
										<div className='animated'>...</div>
									</span>
								</Modal.Header>
								<Modal.Body className='c-scheme-body'>
									<div className='animated'>...</div>
								</Modal.Body>
							</>
						)}
				</Modal>
			</AboutLayout>
		);
}
